(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart"]) return;
  try {
    
  /* Cart quantity +/- buttons */
  document.querySelectorAll('[data-cart-qty-minus]').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var input = btn.parentElement.querySelector('[data-cart-qty-input]');
      var val = parseInt(input.value) || 1;
      input.value = Math.max(0, val - 1);
    });
  });
  document.querySelectorAll('[data-cart-qty-plus]').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var input = btn.parentElement.querySelector('[data-cart-qty-input]');
      input.value = (parseInt(input.value) || 0) + 1;
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  const toggle = document.querySelector('[data-menu-toggle]');
  const nav = document.querySelector('[data-nav]');
  if (toggle && nav) {
    toggle.addEventListener('click', () => {
      const open = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!open));
      nav.classList.toggle('is-open');
      document.documentElement.style.overflow = open ? '' : 'hidden';
    });

    /* Toggle dropdowns on mobile */
    nav.querySelectorAll('.has-dropdown > .header__link').forEach(link => {
      link.addEventListener('click', (e) => {
        if (window.innerWidth <= 768) {
          e.preventDefault();
          const dropdown = link.nextElementSibling;
          if (dropdown) {
            dropdown.classList.toggle('is-open');
            const arrow = link.querySelector('svg');
            if (arrow) {
              arrow.style.transform = dropdown.classList.contains('is-open') ? 'rotate(180deg)' : '';
            }
          }
        }
      });
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  /* Thumbnail gallery */
  var mainImg = document.getElementById('ProductMainImg');
  var thumbs = document.querySelectorAll('.product__thumb');
  if (mainImg && thumbs.length) {
    thumbs.forEach(function(thumb) {
      thumb.addEventListener('click', function() {
        mainImg.src = thumb.dataset.imageUrl;
        mainImg.srcset = '';
        thumbs.forEach(function(t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
      });
    });
  }

  /* Quantity buttons */
  var qtyInput = document.getElementById('ProductQty');
  var qtyMinus = document.querySelector('[data-qty-minus]');
  var qtyPlus = document.querySelector('[data-qty-plus]');
  if (qtyInput && qtyMinus && qtyPlus) {
    qtyMinus.addEventListener('click', function() {
      var val = parseInt(qtyInput.value) || 1;
      qtyInput.value = Math.max(1, val - 1);
    });
    qtyPlus.addEventListener('click', function() {
      qtyInput.value = (parseInt(qtyInput.value) || 1) + 1;
    });
  }

  /* Variant selection */
  var variantJson = document.getElementById('ProductVariants');
  if (variantJson) {
    var variants = JSON.parse(variantJson.textContent);
    var selects = document.querySelectorAll('.product__select');
    var idInput = document.getElementById('ProductVariantId');
    var priceWrap = document.getElementById('ProductPrice');
    var submitBtn = document.querySelector('.product__submit');

    function updateVariant() {
      var selected = [];
      selects.forEach(function(s) { selected.push(s.value); });
      var match = variants.find(function(v) {
        return v.options.every(function(opt, i) { return opt === selected[i]; });
      });
      if (!match) return;

      idInput.value = match.id;

      if (match.compare) {
        priceWrap.innerHTML =
          '<span class="product__price product__price--sale">' + match.price + '</span>' +
          '<span class="product__price-compare">' + match.compare_at_price + '</span>';
      } else {
        priceWrap.innerHTML = '<span class="product__price">' + match.price + '</span>';
      }

      if (match.available) {
        submitBtn.disabled = false;
        submitBtn.textContent = submitBtn.dataset.addText;
      } else {
        submitBtn.disabled = true;
        submitBtn.textContent = submitBtn.dataset.soldText;
      }

      if (match.image && mainImg) {
        mainImg.src = match.image;
        mainImg.srcset = '';
      }

      var url = new URL(window.location);
      url.searchParams.set('variant', match.id);
      window.history.replaceState({}, '', url);
    }

    selects.forEach(function(s) {
      s.addEventListener('change', updateVariant);
    });
  }

  } catch(e) { console.error(e); }
})();
})();
